import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'
import { globalQueryKeys as queryKeys } from '@opallabs/api'
import {
  findResourceOfType,
  type OpalApiResponseDocument,
  workspaces,
} from '@opallabs/api/v3'

type WorkspaceDefaultsResponse = OpalApiResponseDocument<'ReadWorkspaceV3', 200>

export const useGetWorkspaceDefaults = ({
  workspaceId,
}: {
  workspaceId: string
}) => {
  return useQuery({
    queryKey: queryKeys.workspaceDefaults(workspaceId),
    queryFn: async () =>
      workspaces.readSingle({
        path: { workspace_id: workspaceId },
        query: {
          fields: { workspace: ['name', 'workspace_defaults'].join(',') },
          include: ['workspace_defaults'],
        },
      }),
    select: useCallback((responseDocument: WorkspaceDefaultsResponse) => {
      const defaultsId =
        responseDocument.data.relationships.workspace_defaults?.data?.id
      if (!defaultsId) {
        return undefined
      }

      return {
        id: defaultsId,
        defaults: responseDocument.included?.find(
          findResourceOfType('workspace_defaults', 'V3', defaultsId)
        )?.attributes,
      }
    }, []),
  })
}
